import { colors } from '../colors';

const FeatureCard = ({ title, description, icon }) => {
    return (
        <div style={{ backgroundColor: colors.secondary, color: colors.primary, padding: '2rem', borderRadius: '10px', textAlign: 'center', margin: '1rem', flex: 1, minWidth: '280px' }}>
            {icon && <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>{icon}</div>}
            <h3 style={{ fontSize: '1.5rem', marginBottom: '0.5rem' }}>{title}</h3>
            <p>{description}</p>
        </div>
    );
};

const FeaturesSection = () => {
    const features = [
        {
            title: 'Intuitive Plan Builder',
            description: 'Drag-and-drop interface to create comprehensive lesson plans in minutes.',
            icon: '🛠️' // Example icon
        },
        {
            title: 'Collaborative Workspace',
            description: 'Share and co-edit plans with colleagues in real-time.',
            icon: '🤝' // Example icon
        },
        {
            title: 'Resource Library',
            description: 'Access a vast library of templates, activities, and educational materials.',
            icon: '📚' // Example icon
        }
    ];

    return (
        <section style={{ padding: '4rem 2rem', backgroundColor: colors.nBackground }}>
            <h2 style={{ textAlign: 'center', color: colors.primary, fontSize: '2.5rem', marginBottom: '2rem' }}>Why Choose Planna?</h2>
            <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap' }}>
                {features.map(feature => (
                    <FeatureCard key={feature.title} title={feature.title} description={feature.description} icon={feature.icon} />
                ))}
            </div>
        </section>
    );
};

export default FeaturesSection;
